import { applyMiddleware, compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import reducer from "./reducers/index.js";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = configureStore({reducer : {combineReducer: reducer}}, composeEnhancers(applyMiddleware(thunk)))

export default store